import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("./views/account/logout"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  // ------------- Menu ------------- //
  // ------------- Setting ------------- //
  {
    // path: "/dashboard",
    path: "/",
    // name: "dashboard",
    name: "default",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/dashboards/event"),
  },
  // ------------- Banner ------------- //
  {
    path: "/banner",
    name: "banner",
    meta: { authRequired: true },
    component: () => import("./views/banner/list"),
  },
  // ------------- Video ------------- //
  {
    path: "/video",
    name: "video",
    meta: { authRequired: true },
    component: () => import("./views/video/list"),
  },
  // ------------- Setting ------------- //
  {
    path: "/setting/category",
    name: "setting-category",
    meta: { authRequired: true },
    component: () => import("./views/setting/category"),
  },
  {
    path: "/setting/festival",
    name: "setting-festival",
    meta: { authRequired: true },
    component: () => import("./views/setting/festival"),
  },
  {
    path: "/setting/tag",
    name: "setting-tag",
    meta: { authRequired: true },
    component: () => import("./views/setting/tag"),
  },
  {
    path: "/setting/office",
    name: "setting-office",
    meta: { authRequired: true },
    component: () => import("./views/setting/office"),
  },
  // ------------- Blog ------------- //
  {
    path: "/event/list",
    name: "blog-list",
    meta: { authRequired: true },
    component: () => import("./views/event/list"),
  },
  {
    path: "/event/manage",
    name: "blog-manage",
    meta: { authRequired: true },
    component: () => import("./views/event/manage"),
  },
  {
    path: "/event/list-edit",
    name: "blog-list-edit",
    meta: { authRequired: true },
    component: () => import("./views/event/list-edit"),
  },
  {
    path: "/event/manage-edit",
    name: "blog-manage-edit",
    meta: { authRequired: true },
    component: () => import("./views/event/manage-edit"),
  },
  {
    path: "/event/highlight",
    name: "blog-highlight",
    meta: { authRequired: true },
    component: () => import("./views/event/highlight"),
  },
  // ------------- TAT API ------------- //
  {
    path: "/tat/list",
    name: "tat-list",
    meta: { authRequired: true },
    component: () => import("./views/tat/list"),
  },
  {
    path: "/tat/manage",
    name: "tat-manage",
    meta: { authRequired: true },
    component: () => import("./views/tat/manage"),
  },
  {
    path: "/tat/list-apt",
    name: "apt-list",
    meta: { authRequired: true },
    component: () => import("./views/tat/list-apt"),
  },
  {
    path: "/tat/manage-apt",
    name: "apt-manage",
    meta: { authRequired: true },
    component: () => import("./views/tat/manage-apt"),
  },
  // ------------- User ------------- //
  {
    path: "/user",
    name: "user",
    meta: { authRequired: true },
    component: () => import("./views/user/list"),
  },
  // ------------- Report ------------- //
  {
    path: "/report",
    name: "report",
    meta: { authRequired: true },
    component: () => import("./views/report/index"),
  },
  // ------------- Activity ------------- //
  {
    path: "/activity",
    name: "activity",
    meta: { authRequired: true },
    component: () => import("./views/activity/index"),
  },
  {
    path: "/activity/detail",
    name: "activity-detail",
    meta: { authRequired: true },
    component: () => import("./views/activity/detail"),
  },
];
